import React from 'react';
import { Avatar } from '@mui/material';
import {
  AdminPanelSettings as LeagueAdminsIcon,
  EmojiEvents as LeagueIcon,
  GroupAdd as SparesIcon,
} from '@mui/icons-material';
import { buildApiUrl } from '../../utils/unifiedApi';
import { initialsFor } from '../../utils/chatFormat';
import {
  isDirectChannel, isLeagueAdminsChannel, isLeagueChannel, isSparesChannel,
} from '../../utils/chatChannelTypes';

export { isDirectChannel, isLeagueChannel };

// League-wide chats show an icon instead of initials.
const LEAGUE_WIDE_AVATARS = [
  { matches: isLeagueChannel, Icon: LeagueIcon, bgcolor: 'secondary.main', testId: 'league-channel-avatar' },
  { matches: isLeagueAdminsChannel, Icon: LeagueAdminsIcon, bgcolor: 'primary.dark', testId: 'league-admins-channel-avatar' },
  { matches: isSparesChannel, Icon: SparesIcon, bgcolor: 'info.main', testId: 'spares-channel-avatar' },
];

const ChatChannelAvatar = ({ channel, size = 40 }) => {
  const baseSx = {
    width: size,
    height: size,
    color: 'common.white',
    border: '1px solid',
    borderColor: 'divider',
    fontSize: size * 0.4,
    flexShrink: 0,
  };

  const leagueWide = LEAGUE_WIDE_AVATARS.find((a) => a.matches(channel));
  if (leagueWide) {
    const { Icon, bgcolor, testId } = leagueWide;
    return (
      <Avatar alt={channel.name} sx={{ ...baseSx, bgcolor }} data-testid={testId}>
        <Icon sx={{ fontSize: size * 0.55 }} />
      </Avatar>
    );
  }

  if (isDirectChannel(channel)) {
    const photoUrl = channel.directMember?.photoUrl;
    return (
      <Avatar
        src={photoUrl ? buildApiUrl(photoUrl) : undefined}
        alt={channel.name}
        sx={{ ...baseSx, bgcolor: 'primary.main' }}
        data-testid="direct-channel-avatar"
      >
        {initialsFor(channel.name)}
      </Avatar>
    );
  }

  return (
    <Avatar
      src={channel.teamLogoUrl ? buildApiUrl(channel.teamLogoUrl) : undefined}
      alt={channel.name}
      sx={{ ...baseSx, bgcolor: channel.jerseyColorHex || 'primary.main' }}
    >
      {initialsFor(channel.name)}
    </Avatar>
  );
};

export default ChatChannelAvatar;
